export enum UploadStatus {
  FAILED,
  UPLOADED,
  UPLOADING,
}
